export enum AbsatzVorgabe {
  Mpt = 'MPT',
  Stueck = 'STUECK',
}

export class AbsatzProduktivitaetEinstellungen {
  constructor({
    absatzVorgabe,
    zielProduktivitaet,
  }: {
    absatzVorgabe: AbsatzVorgabe;
    zielProduktivitaet: number;
  }) {
    this.absatzVorgabe = absatzVorgabe;
    this.zielProduktivitaet = zielProduktivitaet;
  }

  absatzVorgabe: AbsatzVorgabe;
  readonly zielProduktivitaet: number;
}

export class UmsatzProduktivitaetEinstellungen {
  constructor({ zielProduktivitaet }: { zielProduktivitaet: number }) {
    this.zielProduktivitaet = zielProduktivitaet;
  }
  readonly zielProduktivitaet: number;
}

export class TagebuchEinstellungen {
  constructor({
    absatzProduktivitaet,
    umsatzProduktivitaet,
  }: {
    absatzProduktivitaet: AbsatzProduktivitaetEinstellungen;
    umsatzProduktivitaet: UmsatzProduktivitaetEinstellungen;
  }) {
    this.absatzProduktivitaet = absatzProduktivitaet;
    this.umsatzProduktivitaet = umsatzProduktivitaet;
  }

  readonly absatzProduktivitaet: AbsatzProduktivitaetEinstellungen;
  readonly umsatzProduktivitaet: UmsatzProduktivitaetEinstellungen;
}
